export default __webpack_public_path__ + "static/media/logo.d87785b2.gif";